import React from "react";
import PropTypes from "prop-types";
import { FeedbackIcon } from "../FeedbackIcon";

const INPUT_TYPES = {
    TEXT: "text",
    NUMBER: "number",
};

export function InputCell(props) {
    const validate = (event) => {
        let value = null;
        if (props.type === INPUT_TYPES.TEXT) {
            value = event.target.value;
        }
        if (props.type === INPUT_TYPES.NUMBER) {
            value = parseFloat(event.target.valueAsNumber).toFixed(props.accuracy ? props.accuracy : 0);
        }
        props.onChange({ id: props.id, value, answer: props.answer, numberOfInputs: props.numberOfInputs, feedback: props.feedback });
    };
    const onChange = (event) => {
        let value = null;
        if (props.type === INPUT_TYPES.TEXT) {
            value = event.target.value;
        }
        if (props.type === INPUT_TYPES.NUMBER) {
            value = event.target.valueAsNumber;
        }
        props.onChange({ id: props.id, value, answer: props.answer, numberOfInputs: props.numberOfInputs, feedback: props.feedback });
    };

    const setClassName = () => {
        let className = props.className;
        if (props.showFeedback) {
            className += ` ${props.isCorrect ? "correctOption" : "incorrectOption"}`;
        }
        return className;
    };

    return (
        <td className={setClassName()} colspan={props.colspan}>
            <div className={`dataTable_row_cell_contents`}>
                <input
                    placeholder={props.placeholder}
                    className={`${props.className}_input`}
                    type={props.type}
                    value={!isNaN(props.value) ? props.value : null}
                    onBlur={validate}
                    onChange={onChange}
                    disabled={props.disabled}
                    pattern={props.type == "number" ? "^([-+,0-9.]+)" : null}
                    onWheel={(e) => e.target.blur()}
                />
                <FeedbackIcon isSuccess={props.isCorrect} showFeedback={props.showFeedback} className={`${props.className}_feedback`} feedback={props.feedback} />
            </div>
        </td>
    );
}

InputCell.propTypes = {
    /**
     * Unique id for the cell
     */
    id: PropTypes.string,
    /**
     * Placehodler for the cell
     */
    placeholder: PropTypes.string,
    /*
     * className to be set on component
     */
    className: PropTypes.string,
    /**
     * value to display on input
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * type of the input
     */
    type: PropTypes.oneOf(["text", "num"]),
    /**
     * Boolean feedback on value being correct/incorrect
     */
    isCorrect: PropTypes.bool,
};
